<template>
  <div class="flex items-center justify-center">
    <length-input
      :model-value="LengthInches"
      :step="stepSizeInches"
      :min="stepSizeInches"
      class="w-full text-blue-600 text-lg"
      unit="in"
      @update:model-value="setMelimeterValue($event)"
      @change:model-value="changeMelimeterValue($event)"
    />
    <p class="mx-4">OR</p>
    <length-input
      :model-value="value"
      :step="stepSize"
      :min="min"
      :error="errors ? errors.depth_restriction : ''"
      class="w-full text-blue-600 text-lg"
      unit="mm"
      @update:model-value="update($event)"
    />
  </div>
</template>

<script>
import LengthInput from './LengthInput'

export default {
  components: {
    LengthInput,
  },
  props: {
    value   :Number,
    min     : Number,
    stepSize: Number,
    errors  : Object,
  },
  emits: ['input'],
  data(){
    return {
      timeout: null,
    }
  },
  computed: {
    LengthInches () {
      return this.value ? this.MelimeterToInches(this.value) : null
    },
    stepSizeInches() {
      return this.MelimeterToInches(this.stepSize)
    },
  },
  methods: {
    update(value) {
      this.$emit('input', parseFloat(value))
    },
    setMelimeterValue (value) {
      setTimeout(() => {
        let melimeters = this.InchesToMelimeters(value)
        this.update(melimeters)
      }, 700)
    },
    changeMelimeterValue(value) {
      if (this.LengthInches < value) {
        value = this.value ? this.value + this.stepSize : this.stepSize
        this.update(value)
        return
      }

      value = this.value ? this.value - this.stepSize : this.stepSize
      this.update(this.value - this.stepSize)
    }
  },
}
</script>
